import * as React from 'react';
import * as main from "../../styles/main.module.scss";
import * as screen1 from "./style.module.scss";
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { TaxDeduction } from "../../../../TaxDeduction";
import { Modal } from '../../../../Modal';
import {AccessLimited} from "../../../../AccessLimited";
export const Screen1 = ({ btnText, widget, free=false, hidePrice=false, accessLimited }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel logo={"orange"} phoneColor={"#fff"}/>
        <div className={screen1.screen1__mainDesc}>
          <h1>
            Онлайн-курс
            <span>«Запоминание неправильных глаголов»</span>
          </h1>
          {
            !hidePrice && <span className={screen1.screen1__costOld}>3&nbsp;000&nbsp;&#8381;</span>
          }

          <div className={main.btnBlock}>
            <button className={`btn ${main.mainBtn}`} onClick={()=>{setShowModal(true)}}>
              {
                btnText || `Купить за 990\u00A0₽`
              }
            </button>
          </div>
          {
            !free && <TaxDeduction margin={"30px 0 50px"} align={"center"} font={"18px"}/>
          }
          {
            accessLimited && <AccessLimited margin={"30px 0 50px"} align={"center"} font={"18px"}/>
          }
        </div>
      </div>
      <div className={screen1.screen1__bottom}>
        <div className="container">
          <h2>За 2 часа вы сможете выучить <strong>более 150</strong> самых популярных неправильных глаголов навсегда</h2>
          <span>И этого достаточно:</span>
          <div className={`row ${screen1.screen1__row}`}>
            <div className={`col ${screen1.screen1__col}`}>
              <img src="https://fs.advance.ru/landing-pages/irregular_verbs/conversation.svg" alt="Запись тренинга Запоминание неправильных глаголов"/>
              <p>для свободного <br/> общения</p>
            </div>
            <div className={`col ${screen1.screen1__col}`}>
              <img src="https://fs.advance.ru/landing-pages/irregular_verbs/exam.svg" alt="Запись тренинга Запоминание неправильных глаголов"/>
              <p>для экзаменов <br/> ЕГЭ, FCE, IELTS</p>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        { widget }
      </Modal>
    </header>
  );
};
